import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { Footer } from "./footer";
import { Header } from "./header";
import { useSingleOrderLogin } from "./use-single-order-login";
export function SingleOrderLogin({
  onBack,
  giftButtonClicked,
}: {
  onBack: () => void;
  giftButtonClicked?: () => void;
}) {
  const {
    texts,
    setEmailZip,
    setOrderTrackingNumber,
    submit,
    submitLoad,
    submitDisabled,
    emailZip,
    orderTrackingNumber,
    hideGiftOption,
  } = useSingleOrderLogin();

  const errorUI = submitLoad.error ? (
    <Text textColor="error">{submitLoad.error?.message}</Text>
  ) : null;

  return (
    <Flex flexDirection="column" gap="3xl">
      <Header
        leftAlign
        logo={undefined}
        merchantName={texts.merchantName}
        onBack={onBack}
        subtitle={texts.subtitle}
        title={texts.title}
      />
      <Flex
        align="stretch"
        flex={1}
        flexDirection="column"
        gap="2xl"
        grow={1}
        justify="flex-start"
      >
        <RedoTextInput
          fullWidth
          label={texts.emailZipInputLabel}
          placeholder={texts.emailZipInputPlaceholder}
          required
          setValue={setEmailZip}
          size="md"
          value={emailZip}
        />
        <RedoTextInput
          fullWidth
          label={texts.orderNumberInputLabel}
          placeholder={texts.orderNumberInputPlaceholder}
          required
          setValue={setOrderTrackingNumber}
          size="md"
          value={orderTrackingNumber}
        />

        <RedoButton
          disabled={submitDisabled}
          hierarchy="primary"
          onClick={() => submit()}
          pending={submitLoad.pending}
          size="lg"
          text={texts.startReturnButton}
          theme="normal"
        />
        {errorUI}
      </Flex>

      <Flex align="center" flexDirection="column" gap="md" justify="flex-start">
        {!hideGiftOption && giftButtonClicked && (
          <RedoButton
            hierarchy="link_underline"
            onClick={giftButtonClicked}
            text={texts.giftButton}
          />
        )}
      </Flex>

      <Footer centered />
    </Flex>
  );
}
